/** @flow */

export const EMPLOYEE_QUESTION_TYPE = {
  STANDARD: "STANDARD",
  DINAMYC: "DINAMIC",
};

export const MEDICAL = "MEDICAL";
